import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const userService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Include cookies in requests
  });

  // Interceptor para redirigir al login si la API devuelve Unauthorized
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const addUsuario = async (usuario) => {
    try {
      const response = await instance.post('/user/register', usuario);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getAllUsuarios = async () => {
    try {
      const response = await instance.get('/user');
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getById = async (id) => {
    try {
      const response = await instance.get(`/user/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const editUsuario = async (id, usuario) => {
    try {
      const response = await instance.put(`/user/${id}`, usuario);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const removeUsuario = async (id) => {
    try {
      const response = await instance.delete(`/user/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const toggleUserStatus = async (id, isActive) => {
    try {
      const response = await instance.put(`/user/toggle-status/${id}`, isActive, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };




  return {
    addUsuario,
    getAllUsuarios,
    getById,
    editUsuario,
    removeUsuario,
    toggleUserStatus,

  };
})();

export default userService;
